import { render, staticRenderFns } from "./departDialog.vue?vue&type=template&id=3a3c0a8e"
import script from "./departDialog.vue?vue&type=script&lang=js"
export * from "./departDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports